import Swiper from 'swiper';

let swiperInstance;
function enableSwiper() {
    if (window.innerWidth < 768) {
        if (!swiperInstance) {
            swiperInstance = new Swiper('.swiper-container-columns-section', {
                slidesPerView: 1.3,
                spaceBetween: 10,
                loop: true,
                on: {
                    init: () => {
                        adjustSlideHeights(); // Adjust heights on init
                    },
                    resize: () => {
                        adjustSlideHeights(); // Re-adjust heights when window is resized
                    },
                },
            });
        }
    } else {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }
}

function adjustSlideHeights() {
    const slides = document.querySelectorAll(
        '.swiper-container-columns-section .swiper-slide'
    );
    slides.forEach(slide => {
        slide.style.height = 'auto';
    });
    let maxHeight = 0;
    slides.forEach(slide => {
        const slideHeight = slide.offsetHeight;
        if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
        }
    });
    slides.forEach(slide => {
        slide.style.height = `${maxHeight}px`;
    });
}

export default function loadSwiperForTheme4() {
    if (window.location.pathname.includes('/pos/request-a-quote-j')) {
        window.addEventListener('load', enableSwiper);
        window.addEventListener('resize', enableSwiper);
    }
}
